import { z } from 'zod';

export const RedDotDTO = z.object({
    enable: z.boolean().optional(),
    redDotTxt: z.string().optional(),
});

export type RedDotConfigDTO = z.infer<typeof RedDotDTO>;
